export const IS_DEVELOPMENT = import.meta.env.DEV;
export const TAWK_API_KEY = import.meta.env.VITE_TAWK_API_KEY;
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'no-url-set';
export const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY || 'no-anon-key-set';

export const API_URL = `${SUPABASE_URL}/functions/v1`;
export const PUBLIC_API = `${API_URL}/public-api`;

export const IS_PRODUCTION =
  SUPABASE_URL !== 'https://uwhlqmezhlabjsyrbelb.supabase.co';

console.log('ENVIRONMENT VARIABLES:', {
  IS_DEVELOPMENT,
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  API_URL,
  PUBLIC_API,
  IS_PRODUCTION,
});
